module.exports = __webpack_public_path__ + "static/media/icon-info.1265d1c0.svg";